<template>
  <div>
    <div id="ConsultaDireccion_div" class="">
      <div id="TituloConsultaDireccion_div" class="w-100">
        <h1 style="margin-bottom: 0px;">Historial de acuerdo</h1>
        <!-- <h3 style="margin-top: 0px;">Información del acuerdo de cédula</h3> -->
      </div>
      <div id="encabezado-contenedor-contenido" class="form-inline mt-3">
        <div class="flex-grow-1"><button type="button" @click="regresarAVistaPrincipal" class="btn btn-primary"><i class="fas fa-long-arrow-alt-left" style="font-size:20px;"></i></button></div>
        <div class="flex-grow-1" style="padding-left: 11em;"><h4>Detalles historial de acuerdo</h4></div>
        <div class="flex-grow-1"></div>
      </div>
      <div id="contenedor-historial-acuerdo" class="col-12 contenedor-informacion">
        <div id="ContenidoConsultaDireccion_div" class="mt-3">
          <div class="contenedor-color-negro">
            <h4><i class="fas fa-book"></i>&nbsp;&nbsp;Historial de cédulas</h4>
            <div class="d-flex justify-content-between mt-3">
              <div style="width: 29%">
                <div class="form-group info area" id="Documentos_div">
                  <h5 for="documentos_div">Cédulas</h5>
                  <hr/>
                  <div id="Documentos_div_cedulas_historial">
                    <div :class="[(cedulasDeAcuerdo.length > 10) ? 'form-group mb-1 pr-3' : 'form-group mb-1']" id="documentos_div" v-for="(cedula, index) in cedulasDeAcuerdo" :key="index">
                      <div class="input-group mb-1">
                        <input class="form-control" type="text" v-model="cedula.CedulaId" disabled />
                        <div class="input-group-append">
                          <span class="input-group-text" id="basic-addon2"><input type="radio" :id="'cedula_radio' + cedula.CedulaId" @click="evtVerCedula($event)" name="cedula_radio" :value="cedula.CedulaId" /></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="area form-group" style="width: 69%">
                <h5 for="cedulaInfo_div">Información de cédula {{ folioCedulaSeleccionada }}</h5>
                <hr/>
                <div v-if="!cargandoInformacionCedula" id="cedulaInfo_div" class="row">
                  <div class="form-group info col-12 pr-1" id="Domicilio_div">
                    <h6>Domicilio</h6>
                    <input class="form-control" type="text" v-model="domicilio" disabled />
                  </div>
                  <div class="form-group info col-12 pr-1" id="PersonaANotificar_div">
                    <h6>Persona a notificar</h6>
                    <input class="form-control" type="text" v-model="personaANotificar" disabled />
                  </div>
                  <div class="form-group info col-6 pr-1" id="Estatuso_div">
                    <h6>Estatus</h6>
                    <input class="form-control" type="text" v-model="cedulaEstatus" disabled />
                  </div>
                  <div class="form-group info col-6 " id="Resultado_div">
                    <h6>Resultado</h6>
                    <input class="form-control" type="text" v-model="resultado" disabled />
                  </div>
                  <div class="form-group info col-6 pr-1" id="Resultado_div">
                    <h6>Tipo de razonamiento</h6>
                    <textarea rows="4" class="form-control"  v-model="tipoRazonamiento" disabled />
                  </div>
                  <div class="form-group info col-6" id="ObservacionesAbogado_div">
                    <h6>Observaciones de abogado</h6>
                    <textarea rows="4" class="form-control" v-model="observacionesAbogado" disabled></textarea>
                  </div>
                  <div class="form-group info col-6 pr-1 " id="ObservacionesResultado_div">
                    <h6>Observaciones de resultado</h6>
                    <textarea rows="4" class="form-control" v-model="observacionesResultado" disabled></textarea>
                  </div>
                  <div class="form-group info col-6" id="Documentos_div_cedula">
                    <h6>Documentos</h6>
                    <div class="form-group mb-1" id="documentos_div" v-for="(documento, index) in documentosDeCedula" :key="index">
                      <div class="input-group mb-1">
                        <input class="form-control" type="text" v-model="documento.tipo" disabled />
                        <div class="input-group-append" @click="evtSeleccionDocumento($event)">
                          <span :id="documento.referencia" class="input-group-text"><span :id="documento.referencia" class="fas fa-file"></span></span>
                        </div>
                      </div>
                    </div>
                    <div v-if="documentosDeCedula.length < 1" class="form-group mb-1">
                      <div class="input-group mb-1">
                        <h6 class="text center">Sin documentos</h6>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="cargandoInformacionCedula" class="contenedor-cargando" style="height: 300px ;">
                  <div class="text-center">
                      <i class="fas fa-spinner fa-spin fa-5x"></i>
                      <h4 class="mt-4">Cargando información</h4>
                  </div>
                </div>
                <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="visor-documentos-cedula">
                  <div class="modal-dialog modal-lg modal-dialog-centered">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 v-if="this.campoRequeridoEsValido(documentoCedulaSeleccionado)" class="modal-title">{{ documentoCedulaSeleccionado.tipo }}</h5>
                        <button id="btn-cerrar-visor-documentos-cedula" @click="evtCerrarVisorDocumentoCedula" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                      </div>
                      <div class="modal-body">
                        <div v-if="documentoCedulaSeleccionado != null">
                          <div v-if="TIPO_DOCUMENTOS_CEDULA.anexoResultado == documentoCedulaSeleccionado.tipo" class="d-flex justify-content-center">
                            <div id="paginacion-anexos" class="form-inline mb-3 justify-content-between" style="width: 20%;">
                              <button :disabled="!this.mostrarRegresarVisorAnexos()" @click="evtMostrarAnexoAnterior" type="button" class="btn btn-primary"><i class="fas fa-long-arrow-alt-left"></i></button>
                              <h6>{{ numeroDeAnexo }}/ {{ totalDeAnexos }} </h6>
                              <button :disabled="!this.mostrarSiguienteVisorAnexos()" @click="evtMostrarAnexoSiguiente" type="button" class="btn btn-primary"><i class="fas fa-long-arrow-alt-right"></i></button>
                            </div>
                          </div>
                          <PDFDocument 
                            :url="(this.esExtensionDeWord(documentoCedulaSeleccionado.obj) || TIPO_DOCUMENTOS_CEDULA.principal == documentoCedulaSeleccionado.tipo) ? documentoCedulaSeleccionado.archivo : ''" 
                            :height="'600px'"
                            :key="'VDDCVHA' + contRenderDocumentos"
                            :ArchivoAConvertir="(!this.esExtensionDeWord(documentoCedulaSeleccionado.obj) && TIPO_DOCUMENTOS_CEDULA.principal != documentoCedulaSeleccionado.tipo) ? documentoCedulaSeleccionado.archivo : null" />
                        </div>
                      </div>  
                    </div>
                  </div>
              </div>
              </div>
            </div>
          </div>
          <div id="visor_div" class="contenedor-color-negro mt-3">
            <h4><i class="fas fa-info-circle"></i>&nbsp;&nbsp;Detalles de acuerdo</h4>
            <div class="d-flex justify-content-between mt-3">
              <div style="width: 29%">
                <div class="area">
                  <div v-if="acuerdo != null" id="InformacionCedula_div">
                    <h5>Información de expediente</h5>
                    <hr />
                    <div class="form-group info" id="Juzgado_div">
                      <h6>Juzgado</h6>
                      <input class="form-control" type="text" v-model="juzgado" disabled />
                    </div>
                    <div class="form-group info" id="TipoDocumento_div">
                      <h6>Tipo de Documento</h6>
                      <input class="form-control" type="text" v-model="tipoDeDocumento" disabled />
                    </div>
                    <div class="form-group info" id="Consecutivo_div">
                      <h6>Número de documento</h6>
                      <input class="form-control" type="text" v-model="acuerdo.Expediente.NumeroDeDocumento" disabled />
                    </div>
                    <div class="form-group info" id="Consecutivo_div">
                      <h6>Folio de acuerdo</h6>
                      <input class="form-control" type="text" v-model="acuerdo.AcuerdoIdReferencia" disabled />
                    </div>
                  </div>
                </div>
              </div>
              <div class="area" style="width: 69%">
                <h5 class="mb-3">Documento</h5>
                <PDFDocument 
                  :url="visorDocumentoAcuerdo.url" 
                  :height="visorDocumentoAcuerdo.height"
                  :key="'VDACRVDA' + visorDocumentoAcuerdo.contRender" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import sistemas from '@/../static/js/sistemas'
  import PDFDocument from '@/../src/components/Comunes/PDFDocument'
  import router from '@/router/index'
  import comun from "@/../static/js/comun"
  import api from '@/../static/js/api'
  import axios from 'axios'
  import { mapActions } from 'vuex'

  export default {
    components: {      
      PDFDocument
    },
    data() {
      return {
        acuerdo: null,
        cedulasDeAcuerdo: [],
        juzgado: null,
        tipoDeDocumento: null,
        cedulaSeleccionada: null,
        resultado: 'Sin resultado',
        tipoRazonamiento: 'Sin razonamiento',
        observacionesAbogado: 'Sin observaciones',
        observacionesResultado: 'Sin observaciones',
        visorDocumentoAcuerdo: {
          url: '',
          height: '400px',
          contRender: 0
        },
        cedulaEstatus: null,
        cargandoInformacionCedula: false,
        folioCedulaSeleccionada: null,
        documentosDeCedula: [],
        documentoCedulaSeleccionado: null,
        TIPO_DOCUMENTOS_CEDULA: {
          principal: 'Cédula',
          resultado: 'Resultado',
          anexoResultado: 'Anexos de resultado'
        },
        numeroDeAnexo: 1,
        contRenderDocumentos: 0,
        totalDeAnexos: 0,
        domicilio: 'Sin domicilio',
        personaANotificar: 'Sin persona a notificar'
      }
    },
    methods: {
      evtMostrarAnexoSiguiente: function() {
        this.numeroDeAnexo = (this.numeroDeAnexo > 0) ? (this.numeroDeAnexo + 1) : 0;
        this.evtSeleccionarDocumentoAnexo(this.numeroDeAnexo);
      },
      evtMostrarAnexoAnterior: function() {
        this.numeroDeAnexo = (this.numeroDeAnexo > 0) ? (this.numeroDeAnexo - 1) : 0;
        this.evtSeleccionarDocumentoAnexo(this.numeroDeAnexo);
      },
      evtCerrarVisorDocumentoCedula: function() {
        if(this.documentoCedulaSeleccionado.tipo == this.TIPO_DOCUMENTOS_CEDULA.anexoResultado) {
          this.numeroDeAnexo = 1;
        }
         $('#visor-documentos-cedula').modal('hide');
      },
      mostrarRegresarVisorAnexos: function() { 
        let mostrar = false;
        if(this.numeroDeAnexo > 1) {
          mostrar = true;
        }
        return mostrar;
      },
      mostrarSiguienteVisorAnexos: function() { 
        let mostrar = false;
        if(this.numeroDeAnexo < this.totalDeAnexos) {
          mostrar = true;
        }
        return mostrar;
      },
      evtSeleccionDocumento: function(evento) {
        this.documentoCedulaSeleccionado = null;
        const REFERENCIA_DOCUMENTO = evento.target.getAttribute('id');
        this.documentosDeCedula.filter(dc => dc.referencia == parseInt(REFERENCIA_DOCUMENTO)).forEach(d => {
          if(d.tipo == this.TIPO_DOCUMENTOS_CEDULA.anexoResultado) {
            this.evtSeleccionarDocumentoAnexo(this.numeroDeAnexo);
          }
          else {
            this.documentoCedulaSeleccionado = d;
            this.contRenderDocumentos ++;
          }
          //console.log('docSel::',this.documentoCedulaSeleccionado.archivo);
          $('#visor-documentos-cedula').modal('show');
        });
      },
      evtSeleccionarDocumentoAnexo: function(numeroAnexo) { 
        let indexAnexo = (numeroAnexo - 1);
        let documentosAnexo = this.documentosDeCedula.find(d => d.tipo == this.TIPO_DOCUMENTOS_CEDULA.anexoResultado);
        //console.log('busquea::',documentosAnexo);
        if(documentosAnexo.archivo.length > 0 && numeroAnexo <= documentosAnexo.archivo.length) {
          this.documentoCedulaSeleccionado = {
            archivo: documentosAnexo.archivo[indexAnexo],
            obj: documentosAnexo.obj[indexAnexo].AnexoRuta,
            tipo: documentosAnexo.tipo
          }
          this.contRenderDocumentos ++;
        }
      },
      regresarAVistaPrincipal: function() {
        router.push({ name: "DetallesConsultaDireccion" });
      },
      evtVerCedula: function(evento) {
        const ID_CEDULA_SELECCIONADA = parseInt(evento.target.value);
        this.cargandoInformacionCedula = true;
        this.limpiarDatosCedula();
        const MARCAR_CEDULA_INICIO = false;
        this.obtenerCedulaSeleccionada(ID_CEDULA_SELECCIONADA, MARCAR_CEDULA_INICIO);
        this.asignarValoresDeCedula(this.cedulaSeleccionada);
      },
      limpiarDatosCedula: function() {
        this.resultado = 'Sin resultado';
        this.tipoRazonamiento = 'Sin razonamiento';
        this.observacionesAbogado = 'Sin observaciones';
        this.observacionesResultado = 'Sin observaciones';
        this.cedulaSeleccionada = null;
        this.totalDeAnexos = 0;
        this.numeroDeAnexo = 1;
      },
      obtenerHistorialAcuerdo: function() {
        const SERVIDOR = api.conexion;
        const METODO_API_OBTENER = api.SINOJ.sistema.consultas.consultaDireccion.ObtenerHistorialAcuerdo;
        let urlApi = SERVIDOR + METODO_API_OBTENER;
        let peticionArchivos = false;
        let peticionAPI = {
          Acuerdo: { AcuerdoIdReferencia: this.acuerdo.AcuerdoIdReferencia },
          esPrueba: false
        }
        let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
        comun.SeEstaCargandoInformacion(true);
        axios.post(urlApi, peticionAPI, headerPeticion)
            .then(respuesta => {            
                if (respuesta.data.SiHayError) {
                    let mensajeError = respuesta.data.Error.Mensaje;
                    console.log(mensajeError);
                    comun.mensajeDeAlerta(mensajeError, null, null);
                } 
                else {
                    let { Cedulas } = respuesta.data;
                    if(Cedulas != null && Cedulas.length > 0) {
                        this.cedulasDeAcuerdo = Cedulas;
                        const MARCAR_CEDULA_INICIO = true;
                        this.obtenerCedulaSeleccionada(this.cedulaSeleccionada, MARCAR_CEDULA_INICIO);
                        this.cargandoInformacionCedula = true;
                        this.asignarValoresDeCedula(this.cedulaSeleccionada);
                    }
                }
                comun.SeEstaCargandoInformacion(false);
            })
            .catch(excepcion => {
                comun.SeEstaCargandoInformacion(false);
                console.log(excepcion);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
        ); 
      },
      campoRequeridoEsValido: function(campo) { 
        let esValido = false
        if(typeof campo === 'string' || campo instanceof String) {
            // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
            if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                esValido = true;
            }
        }
        else if (typeof campo === 'number' || campo instanceof Number) {
            // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
            if (campo != null && campo != undefined && campo > 0) {
                esValido = true;
            }
        }
        else if (typeof campo === 'array' || campo instanceof Array) {
            // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
            if (campo != null && campo != undefined && campo.length > 0) {
                esValido = true;
            }
        }
        else {
            if (campo != null && campo != undefined) {
                esValido = true;
            }
        }
        return esValido;
      },
      obtenerCedulaSeleccionada: function(cedulaId, marcarCedulaInicio) { debugger
        this.cedulasDeAcuerdo.filter(c => c.CedulaId == cedulaId).forEach(cbd => {
          this.cedulaSeleccionada = cbd;
        });
        if(marcarCedulaInicio) {
          this.$nextTick(() => {
            $("#cedula_radio" + cedulaId).prop('checked', true);
          });
        }
      },
      descargarArchivo: async function(rutaArchivo) {
        //console.log('rutaArchivvooooo::',rutaArchivo);
        let archivo = null;
        const METODO_DESCARGA = `${api.conexion}${api.Comun.funcion.DescargarArchivo}?rutaDelArchivo=${rutaArchivo}`;
        try {
          if(this.campoRequeridoEsValido(rutaArchivo)) {
            const PETICION_DESCARGA = await axios.get(METODO_DESCARGA, { responseType: 'blob' });
            const ARCHIVO_DESCARGADO = await PETICION_DESCARGA.data;
            let tipoArchivo = ARCHIVO_DESCARGADO.type;
            // para pdf la API regresa un blob tipo application/octet-stream con arrayBuffer que no adminte el Object html del visos.
            // solo hay que cambiar el tipo a uno que admita el cual es 'application/pdf'. 
            if(this.campoRequeridoEsValido(tipoArchivo) && tipoArchivo.startsWith('application/octet-stream')) {
              tipoArchivo = 'application/pdf';
            }
            archivo = new File([ARCHIVO_DESCARGADO], 'archivoAnexo', { type: tipoArchivo });
          }
        }
        catch(exeption) {
          console.log(exeption);
        }
        return archivo;
      },
      asignarValoresDeDocumentosCedula: function(cedula) { debugger
        let { ArchivoRuta, Resultado } = cedula;
        let listaDeDocumentos = [];
        if(this.campoRequeridoEsValido(ArchivoRuta))
          listaDeDocumentos.push({ referencia: 1, tipo: this.TIPO_DOCUMENTOS_CEDULA.principal, obj: ArchivoRuta });

        if(this.campoRequeridoEsValido(Resultado)) {
          if(this.campoRequeridoEsValido(Resultado.ArchivoResultado_Ruta))
            listaDeDocumentos.push({ referencia: 2, tipo: this.TIPO_DOCUMENTOS_CEDULA.resultado, obj: Resultado.ArchivoResultado_Ruta });
          if(this.campoRequeridoEsValido(Resultado.Anexos)) {
            if(Resultado.Anexos.length > 0)
              listaDeDocumentos.push({ referencia: 3, tipo: this.TIPO_DOCUMENTOS_CEDULA.anexoResultado, obj: Resultado.Anexos });
          }
        }
        listaDeDocumentos.forEach(async (d) => {
          switch(d.tipo) {
            case this.TIPO_DOCUMENTOS_CEDULA.principal:
              d.archivo = d.obj;
            break;
            case this.TIPO_DOCUMENTOS_CEDULA.resultado:
              let esDescarga = !this.esExtensionDeWord(d.obj);
              if(esDescarga) {
                d.archivo = await this.descargarArchivo(d.obj);
              }
              else {
                d.archivo = d.obj;
              }
            break;
            case this.TIPO_DOCUMENTOS_CEDULA.anexoResultado:
              let anexos = d.obj;
              d.archivo = [];
              if(anexos.length > 0) {
                anexos.forEach(async (a) => {
                  let archivoDescargado = await this.descargarArchivo(a.AnexoRuta);
                  d.archivo.push(archivoDescargado);
                });
                this.totalDeAnexos = anexos.length;
              }
            break;
            default:
              break;
          }
        });
        this.documentosDeCedula =  listaDeDocumentos;
        this.cargandoInformacionCedula = false;
        //console.log('listaDocumentosCompleta::',this.documentosDeCedula);
      },
      obtenerNombreArchivo: function(rutaCompleta) {
        let obtenerNombreArchivo = null;
        if(this.campoRequeridoEsValido(rutaCompleta)) {
            const RUTA_ARCHIVO = rutaCompleta.split('\\');
            obtenerNombreArchivo = RUTA_ARCHIVO[RUTA_ARCHIVO.length -1];
        }
        return obtenerNombreArchivo;
      },
      esExtensionDeWord: function(rutaCompleta) {
        let nombreArchivo = this.obtenerNombreArchivo(rutaCompleta);
        let esArchivoWord = false;
        if(this.campoRequeridoEsValido(nombreArchivo)) {
          let nombreArray = nombreArchivo.split('.');
          const EXTENSION = nombreArray[nombreArray.length -1].toUpperCase();
          if(EXTENSION == 'DOC' || EXTENSION == 'DOCX') {
            esArchivoWord = true;
          }
        }
        return esArchivoWord;
      },
      asignarValoresDeResultado: function(resultado) {
        if(this.campoRequeridoEsValido(resultado)) {
          let { FechaResultado, ObservacionesResultado, TipoRazon, TipoResultado } = resultado;
          this.resultado = (this.campoRequeridoEsValido(TipoResultado)) ? TipoResultado.Nombre : 'Sin resultado';
          this.tipoRazonamiento = (this.campoRequeridoEsValido(TipoRazon)) ? TipoRazon.Nombre : 'Sin razon';
          this.observacionesResultado = (this.campoRequeridoEsValido(ObservacionesResultado)) ? ObservacionesResultado : 'Sin observaciones';
        }
      },
      asignarValoresDeCedula: function(cedula) {
        //console.log('valorDeCedula::',cedula);
        let { CedulaId, Estatus, Resultado, ObservacionesDeAbogados, PersonasANotificar } = cedula;
        this.cedulaEstatus = (this.campoRequeridoEsValido(Estatus)) ? Estatus.Nombre : 'Sin estatus'; 
        this.concatenarObservacionesAbogados(ObservacionesDeAbogados);
        this.asignarValoresDeResultado(Resultado);
        this.asignarValoresDeDocumentosCedula(cedula);

        this.domicilio = 'Sin Domicilio';
        this.personaANotificar = 'Sin Persona a Notificar';
        if(this.campoRequeridoEsValido(PersonasANotificar)) {
          if(PersonasANotificar[0].Domicilios != null && PersonasANotificar[0].Domicilios.length > 0) {
              const DOMICILIO_OBJ = PersonasANotificar[0].Domicilios[0];
              let infAdicionalNumExt = (this.campoRequeridoEsValido(DOMICILIO_OBJ.InformacionAdicionalDeNumeroExterior)) ? ` ${ DOMICILIO_OBJ.InformacionAdicionalDeNumeroExterior }` : '';
              let numInterior = (this.campoRequeridoEsValido(DOMICILIO_OBJ.NumeroInterior)) ? `int ${ DOMICILIO_OBJ.NumeroInterior.toString().trim() }` : '';
              if(this.campoRequeridoEsValido(DOMICILIO_OBJ.Fraccionamiento)) {
                  this.domicilio = `${ DOMICILIO_OBJ.Calle } #${ DOMICILIO_OBJ.NumeroExterior }${ infAdicionalNumExt } ${ numInterior }, ${ DOMICILIO_OBJ.Fraccionamiento.Nombre }, ${ DOMICILIO_OBJ.Fraccionamiento.Municipio.Nombre }`;
              }
              else {
                  /* 
                      para los casos de domicilios con fraccionamiento que no pertenece al catalogo de fraccionamientos, se guarda la informacion el un solo campo (008FraccionamientoFueraDeCatalogo => FraccionamientoFueraDeCatalogo)
                      con el siguiente formato NOMBRE_FRACCIONAMIENTO, NOMBRE_MUNICIPIO, si se modifica posteriormenete este formato se tendra que reemplazar esta 
                      logica.
                    */
                  let fraccionamientoCompuesto = DOMICILIO_OBJ.FraccionamientoFueraDeCatalogo.split(',');
                  let nombreFraccionamiento = fraccionamientoCompuesto[0];
                  let nombreMunicipio = fraccionamientoCompuesto[1];
                  this.domicilio = `${ DOMICILIO_OBJ.Calle } #${ DOMICILIO_OBJ.NumeroExterior }${ infAdicionalNumExt } ${ numInterior }, ${ nombreFraccionamiento }, ${ nombreMunicipio }`;
              }

              /* const DOMICILIO_OBJ = PersonaANotificar.Domicilios[0];
              let infAdicionalNumExt = (this.campoRequeridoEsValido(DOMICILIO_OBJ.InformacionAdicionalDeNumeroExterior)) ? ` ${ DOMICILIO_OBJ.InformacionAdicionalDeNumeroExterior }` : '';
              let numInterior = (this.campoRequeridoEsValido(DOMICILIO_OBJ.NumeroInterior)) ? `int ${ DOMICILIO_OBJ.NumeroInterior.toString().trim() }` : '';
              this.domicilio = `${ DOMICILIO_OBJ.Calle } #${ DOMICILIO_OBJ.NumeroExterior }${ infAdicionalNumExt } ${ numInterior }, ${ DOMICILIO_OBJ.Fraccionamiento.Nombre }, ${ DOMICILIO_OBJ.Fraccionamiento.Municipio.Nombre }`; */
          }
          
          if(this.campoRequeridoEsValido(PersonasANotificar[0].DatosGenerales)) {
              const { Fisica, Moral } = PersonasANotificar[0].DatosGenerales;
              if(this.campoRequeridoEsValido(Fisica))
                  this.personaANotificar = `${ Fisica.Nombre.toUpperCase().trim() } ${ Fisica.ApellidoPaterno.toUpperCase().trim() }${ (this.campoRequeridoEsValido(Fisica.ApellidoMaterno)) ? (" " + Fisica.ApellidoMaterno.toUpperCase().trim()) : "" }`; 
              else if(this.campoRequeridoEsValido(Moral))
                  this.personaANotificar = `${ Moral.Nombre.trim() }`; 
          }
        }

        this.folioCedulaSeleccionada = `[ folio: #${CedulaId} ]`;
      },
      concatenarObservacionesAbogados: function(observaciones) {
        if(this.campoRequeridoEsValido(observaciones)) {
          this.observacionesAbogado = (observaciones.length > 0) ? '' : this.observacionesAbogado;
          for(let i=0; i<observaciones.length; i++) {
            this.observacionesAbogado += `[${(i + 1)}] .-\n`;
            this.observacionesAbogado += `${observaciones[i].Observaciones}\n`;
          }
        }
      },
      asignarValoresDeAcuerdo: function(acuerdo) {
        let { Expediente, Ruta } = acuerdo;
        this.juzgado = (this.campoRequeridoEsValido(Expediente.Juzgado.Nombre)) ? Expediente.Juzgado.Nombre : 'Sin juzgado';
        this.tipoDeDocumento = (this.campoRequeridoEsValido(Expediente.TipoDocumento.Nombre)) ? Expediente.TipoDocumento.Nombre : 'Sin tipo de documento';
        this.visorDocumentoAcuerdo.url = Ruta;
      },
      asignarValoresComplementariosCedula: function(cedula) {

      },
      ...mapActions([
        'A_SINOJ_establecerConsultaDeDireccion_Variables'
      ]) 
    },
    created() { debugger
      const PARAMETROS_VISTA = router.history.current.params;
        if(!this.campoRequeridoEsValido(PARAMETROS_VISTA.acuerdo)) {
            router.push({ name: "ConsultaDireccion"});
        }
        else {
            this.acuerdo = PARAMETROS_VISTA.acuerdo;
            this.cedulaSeleccionada = PARAMETROS_VISTA.cedulaSeleccionada;
            this.asignarValoresDeAcuerdo(this.acuerdo);
            this.obtenerHistorialAcuerdo();
        }
    },
    beforeRouteLeave (to, from, next) {
        const VISTA_PADRE = 'DetallesConsultaDireccion';
        if(to.name != VISTA_PADRE) {
          this.A_SINOJ_establecerConsultaDeDireccion_Variables(null);
        }
        next();
    }
  }
</script>
<style scoped>
#Documentos_div_cedula span {
  cursor: pointer;
}

#encabezado-contenedor-contenido {
  background-color: rgb(44, 43, 43);
  padding: 10px;
}

#encabezado-contenedor-contenido .btn {
  background-color: black;
  padding-left: 15px;
  padding-right: 15px;
}

.contenedor-informacion {
  background-color: #323335;
  padding: 25px;
}

#Documentos_div_cedulas_historial {
  max-height: 380px;
  overflow-y: auto;
}

#paginacion-anexos button:disabled {
  background-color: black;
}

textarea {
  padding: 0.6em !important;
}

#visor-documentos-cedula .modal-lg {
    max-width: 70% !important;
}

.modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}

.contenedor-color-negro {
  padding: 1.5em;
  background-color: #2c2d31;
  box-shadow: 0px 6px 20px 8px #161616;
}

.contenedor-cargando {
    height: 40px;
    height: 21rem;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/SINOJ/Consultas/ConsultaDireccion/HistorialAcuerdo.vue